export const FULL = 'full'
export const DATE_SHORT = 'dateShort'
export const DATE_LONG = 'dateLong'
export const ISO_DATE = 'dateISO'
export const NAMED_MONTH_WITH_YEAR = 'namedMonthWithYear'
export const TIME = 'time'
export const NAMED_WEEKDAY_WITH_YEAR_WITH_TIME = 'namedWeekdayWithYearWithTime'
export const NAMED_WEEKDAY_WITH_YEAR = 'namedWeekdayWithYear'

export type DateVariant =
  | typeof FULL
  | typeof DATE_SHORT
  | typeof DATE_LONG
  | typeof ISO_DATE
  | typeof NAMED_MONTH_WITH_YEAR
  | typeof TIME
  | typeof NAMED_WEEKDAY_WITH_YEAR_WITH_TIME
  | typeof NAMED_WEEKDAY_WITH_YEAR

export function formatDate(
  dateString: string | Date,
  variant: DateVariant = FULL,
  locale: string = 'de'
): string {
  if (!dateString) return ''

  const date = new Date(dateString)
  if (isNaN(date.getTime())) return ''

  if (variant === ISO_DATE) {
    return date.toISOString().slice(0, 10) // 'YYYY-MM-DD'
  }

  const is = (...variants: string[]) => variants.includes(variant)

  return new Intl.DateTimeFormat(locale, {
    year: is(
      FULL,
      DATE_LONG,
      NAMED_MONTH_WITH_YEAR,
      NAMED_WEEKDAY_WITH_YEAR_WITH_TIME,
      NAMED_WEEKDAY_WITH_YEAR
    )
      ? 'numeric'
      : '2-digit',
    month: is(NAMED_MONTH_WITH_YEAR) ? 'long' : '2-digit',
    weekday: is(NAMED_WEEKDAY_WITH_YEAR_WITH_TIME, NAMED_WEEKDAY_WITH_YEAR) ? 'long' : undefined,
    ...(!is(NAMED_MONTH_WITH_YEAR) && { day: '2-digit' }),
    ...(is(FULL, TIME, NAMED_WEEKDAY_WITH_YEAR_WITH_TIME) && {
      hour: '2-digit',
      minute: '2-digit',
    }),
    hour12: false,
  }).format(date)
}
